import { fromCognitoIdentityPool } from '@aws-sdk/credential-provider-cognito-identity';
import { AwsClient } from 'aws4fetch';

const IDENTITY_POOL_ID = import.meta.env.VITE_AWS_COGNITO_IDENTITY_POOL_ID;
const REGION = import.meta.env.VITE_AWS_REGION || 'ap-southeast-2';

const credentialProvider = fromCognitoIdentityPool({
  clientConfig: { region: REGION },
  identityPoolId: IDENTITY_POOL_ID,
});

let cachedCredentials = null;

// Refresh credentials 60 seconds before expiry to avoid using near-expired tokens
const EXPIRY_BUFFER_MS = 60 * 1000;

async function getCredentials() {
  const now = Date.now();

  if (
    cachedCredentials &&
    cachedCredentials.expiration &&
    cachedCredentials.expiration.getTime() - EXPIRY_BUFFER_MS > now
  ) {
    return cachedCredentials;
  }

  cachedCredentials = await credentialProvider();
  return cachedCredentials;
}

export async function signedFetch(input, init) {
  const credentials = await getCredentials();

  const client = new AwsClient({
    accessKeyId: credentials.accessKeyId,
    secretAccessKey: credentials.secretAccessKey,
    sessionToken: credentials.sessionToken,
    region: REGION,
    service: 'appsync',
  });

  const request = new Request(input, init);
  const signedRequest = await client.sign(request);

  return fetch(signedRequest);
}
